import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { computed } from "vue";
import { ArtifactLevelInputProps } from "@/types";
import { TypeIcons } from "@/util";
import { artifactTypeApiStore, permissionStore } from "@/hooks";
import { Typography } from "@/components/common/display";


/**
 * Renders an input for changing the icon for an artifact type.
 */
const __default__ = {
  name: "TypeIconInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifactType: {}
  },
  setup(__props: any) {

const props = __props;

const currentColor = computed(() => props.artifactType.color);

const iconOptions = computed(() =>
  TypeIcons.map((icon) => {
    const selected = props.artifactType.icon === icon;

    return {
      icon,
      label: "",
      value: icon,
      text: !selected,
      outlined: selected,
      class: selected ? "button-group-selected" : "",
    };
  })
);

const icon = computed({
  get(): string {
    return props.artifactType.icon;
  },
  set(iconId: string) {
    props.artifactType.icon = iconId;

    artifactTypeApiStore.handleSave(props.artifactType);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Typography), {
      variant: "caption",
      color: "primary",
      value: "Icon"
    }),
    _hoisted_2,
    _createVNode(_component_q_btn_toggle, {
      modelValue: icon.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((icon).value = $event)),
      flat: "",
      style: {"flex-wrap":"wrap"},
      options: iconOptions.value,
      disable: !_unref(permissionStore).isAllowed('project.edit_data'),
      "toggle-color": currentColor.value,
      "data-cy": "button-type-options-icon"
    }, null, 8, ["modelValue", "options", "disable", "toggle-color"])
  ]))
}
}

})